import { lazy, Suspense, useEffect, useRef } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import HomePage from './pages/HomePage'

// Fire a GA4 page_view on every client-side route change. The initial pageview
// is already sent by gtag('config', ...) in the HTML shell, so we skip the first
// effect run to avoid double-counting.
function RouteAnalytics() {
  const location = useLocation()
  const isFirst = useRef(true)
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false
      return
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_location: window.location.href,
        page_path: location.pathname + location.search,
        page_title: document.title,
      })
    }
  }, [location.pathname, location.search])
  return null
}

const AdminLogin = lazy(() => import('./pages/AdminLogin'))
const WaitlistSignups = lazy(() => import('./pages/WaitlistSignups'))
const AdminGBP = lazy(() => import('./pages/AdminGBP'))
const PatientGrowthOnboarding = lazy(() => import('./pages/PatientGrowthOnboarding'))
const PracticeLogin = lazy(() => import('./pages/PracticeLogin'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const PracticeSettings = lazy(() => import('./pages/PracticeSettings'))
const Patients = lazy(() => import('./pages/Patients'))
const BookingPage = lazy(() => import('./pages/BookingPage'))
const BookingConfirmation = lazy(() => import('./pages/BookingConfirmation'))
const BookingCancelled = lazy(() => import('./pages/BookingCancelled'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))

function App() {
  return (
    <div className="min-h-screen bg-white">
      <RouteAnalytics />
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<PracticeLogin />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/waitlist" element={<WaitlistSignups />} />
          <Route path="/admin/gbp" element={<AdminGBP />} />
          <Route path="/onboarding" element={<PatientGrowthOnboarding />} />
          <Route path="/settings" element={<PracticeSettings />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/book/:clinicId" element={<BookingPage />} />
          <Route path="/booking/confirmation" element={<BookingConfirmation />} />
          <Route path="/booking/cancelled" element={<BookingCancelled />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </Suspense>
    </div>
  )
}

export default App
